import React, {Component} from 'react';

import Axios from 'axios';
import Modal from 'react-modal';

import {convertDateToString} from '../Functions/ConvertDateToString';

const thumbsUpIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/thumbs-up-icon.png';
const thumbsUpBlueIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/thumbs-up-blue-icon.png';
const thumbsDownIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/thumbs-down-icon.png';
const thumbsDownOrangeIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/thumbs-down-orange-icon.png';

class DecideOnCandidate extends Component {
    constructor(props) {
      super(props)
      this.state = {
        formHasChangedArray: [],
        hoursPerWeekOptions: [],
        hourlyPayRangeOptions: [],
        onsiteOptions: ['','Always','Somtimes','Remote'],
        selectedIndex: 0
      }

      this.retrieveData = this.retrieveData.bind(this)
      this.closeModal = this.closeModal.bind(this)

      this.formChangeHandler = this.formChangeHandler.bind(this)
      this.likeClicked = this.likeClicked.bind(this)
      this.calculateMatches = this.calculateMatches.bind(this)
      this.connectEmployer = this.connectEmployer.bind(this)
      this.saveFeedback = this.saveFeedback.bind(this)
      this.makeOffer = this.makeOffer.bind(this)
      this.sendOffer = this.sendOffer.bind(this);

    }

    componentDidMount() {
      console.log('componentDidMount called')

      this.retrieveData()
    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called ', this.props)

      if (this.props.orgCode !== prevProps.orgCode || this.props.accountCode !== prevProps.accountCode || this.props.roleName !== prevProps.roleName) {
        this.retrieveData()
      } else if (this.props.selectedApplication !== prevProps.selectedApplication && this.props.selectedIndex !== prevProps.selectedIndex) {
        this.retrieveData()
      }
    }

    retrieveData() {
      console.log('retrieveData called within decideOnCandidate', this.props)

      const emailId = localStorage.getItem('email');
      const cuFirstName = localStorage.getItem('firstName');
      const cuLastName = localStorage.getItem('lastName');
      const orgFocus = localStorage.getItem('orgFocus');
      const roleName = localStorage.getItem('roleName');

      const selectedApplication = this.props.selectedApplication
      let selectedIndex = this.props.selectedIndex
      if (!selectedIndex) {
        selectedIndex = 0
      }

      const selectedJob = this.props.selectedJob
      const applications = this.props.applications
      const selectedBenchmark = this.props.selectedBenchmark
      const accountCode = this.props.accountCode
      const orgCode= this.state.orgCode
      const id = this.props.id

      this.setState({
        emailId, cuFirstName, cuLastName, orgFocus, roleName, selectedApplication, selectedIndex,
        selectedJob, applications, selectedBenchmark, accountCode, id
      })

      Axios.get('/api/workoptions')
      .then((response) => {
        console.log('Work options query tried', response.data);

        if (response.data.success) {
          console.log('Work options query succeeded')

          this.setState({
            hoursPerWeekOptions: response.data.workOptions[0].hoursPerWeekOptions,
            hourlyPayRangeOptions: response.data.workOptions[0].hourlyPayOptions,
            annualPayRangeOptions: response.data.workOptions[0].annualPayOptions,
          })
        }
      });

      Axios.get('/api/assessment/questions')
      .then((response) => {
          //console.log('O*Net worked', response.data.body, this);
          console.log('show me response', response.data)
          if ( response.data.success === true ) {
            console.log('o-net query worked')

            let wpQuestions = []
            for (let i = 1; i <= response.data.assessments.workPreferenceQuestions.length; i++) {
              wpQuestions.push({ name: response.data.assessments.workPreferenceQuestions[i - 1].name })
            }

            this.setState({ wpQuestions })

          } else {
            console.log('Assessment question query failed', response.data.message)
          }
      }).catch((error) => {
          console.log('O*NET did not work', error);
      });

      let postingIds = [id]
      Axios.get('/api/offers/bypostings', { params: { postingIds } })
      .then((response) => {
        console.log('offers by postings query attempted', response.data);

        if (response.data.success) {
          console.log('offers by postings query worked')
          let offer = null
          let offerMessage = null
          if (response.data.offers && response.data.offers.length > 0) {
            offer = response.data.offers[0]
            if (!offer.decision) {
              offerMessage = "Offer extended. Awaiting decision."
            } else if (offer.decision === 'accept') {
              offerMessage = "This candidate has accepted your offer"
            } else {
              // rejected
              offerMessage = "This candidate has rejected your offer"
            }
          }
          this.setState({ offer, offerMessage })

        } else {

        }
      }).catch((error) => {
          console.log('Offers by postings query did not work for some reason', error);
      });

      if (selectedJob || applications || selectedBenchmark) {

        //obtain email id from localStorage
        let email = localStorage.getItem('email');
        let username = localStorage.getItem('username');
        let cuFirstName = localStorage.getItem('firstName');
        let cuLastName = localStorage.getItem('lastName');
        let activeOrg = localStorage.getItem('activeOrg')

        let formHasChangedArray = []

        let payRange = selectedJob.payRange
        let pay = ''

        if (selectedJob) {

          let startDate = convertDateToString(selectedJob.startDate,'first10')
          let endDate = convertDateToString(selectedJob.endDate,'first10')

          let hoursPerWeek = selectedJob.hoursPerWeek

          if (payRange && payRange.includes(" - ")) {

            let number1 = Number(payRange.substring(1,3))
            let number2 = Number(payRange.substring(7,9))
            pay = ((number1 + number2) / 2).toString()

          } else if (payRange && payRange.includes("+")) {
            pay = payRange.substring(1,4)
          } else if (payRange === "Less") {
            pay = '9'
          } else if (payRange === "Unpaid") {
            pay = '0'
          } else if (payRange === "Wide Range") {
            pay = '15'
          }

          if (email) {

            let orgMode = true
            if (!activeOrg || activeOrg === '' || activeOrg === 'guidedcompass') {
              orgMode = false
            }

            Axios.get('/api/org', { params: { orgCode } })
            .then((response) => {
              console.log('Org info query attempted in DecideOnCandidate', response.data, activeOrg);

              if (response.data.success) {
                console.log('org info query worked')

                this.setState({
                    org: activeOrg,

                    orgName: response.data.orgInfo.orgName,
                    orgURL: response.data.orgInfo.orgURL,
                    orgType: response.data.orgInfo.orgType,
                    orgProgramName: response.data.orgInfo.orgProgramName,
                    orgDescription: response.data.orgInfo.orgDescription,
                    orgMission: response.data.orgInfo.orgMission,

                    orgContactFirstName: response.data.orgInfo.contactFirstName,
                    orgContactLastName: response.data.orgInfo.contactLastName,
                    orgContactTitle: response.data.orgInfo.contactTitle,
                    orgContactEmail: response.data.orgInfo.contactEmail,
                    requestToInterview: response.data.orgInfo.requestToInterview

                });

              } else {
                console.log('org info query did not work', response.data.message)
              }

            }).catch((error) => {
              console.log('Org info query did not work for some reason', error);
            });

            Axios.get('/api/account', { params: { accountCode} })
            .then((response) => {
              console.log('Account info query attempted in decideOnCandidate', response.data, accountCode);

              if (response.data.success) {
                console.log('account info query worked')

                const employerName = response.data.accountInfo.employerName
                const employerURL = response.data.accountInfo.employerURL
                const workLocation = response.data.accountInfo.employerLocation

                let employerContactFirstName = response.data.accountInfo.contactFirstName
                if (selectedJob.employerContactFirstName) {
                  employerContactFirstName = selectedJob.employerContactFirstName
                }
                let employerContactLastName = response.data.accountInfo.contactLastName
                if (selectedJob.employerContactLastName) {
                  employerContactLastName = selectedJob.employerContactLastName
                }
                let employerContactEmail = response.data.accountInfo.contactEmail
                if (selectedJob.employerContactEmail) {
                  employerContactEmail = selectedJob.employerContactEmail
                }

                this.setState({ employerName, employerURL, employerContactFirstName, employerContactLastName, employerContactEmail,
                  workLocation });
              }
            })

            const postingId = selectedJob._id
            const isPerpetual = selectedJob.isPerpetual
            let field = selectedJob.field
            let workFunction = ''
            let industry = ''
            if (field && field !== '') {
              let fieldArray = field.split('|')
              workFunction = fieldArray[0].trim()
              industry = fieldArray[1].trim()
            }

            const description = selectedJob.description

            const orgName = selectedJob.orgName
            const orgContactEmail = selectedJob.orgContactEmail
            const pathways = selectedJob.pathways

            this.setState({
                emailId: email, username, cuFirstName, cuLastName,
                orgMode, org: activeOrg, formHasChangedArray,

                selectedJob,
                benchmark: selectedBenchmark, pay, startDate, endDate, hoursPerWeek,
                postingId, isPerpetual, workFunction,industry, description,

                orgName, orgContactEmail, pathways
            });
          }
        }

      } else if (accountCode) {
        //should require person to be authorized, but will fix that later

        Axios.get('/api/account', { params: { accountCode } })
        .then((response) => {
          console.log('Account info query attempted', response.data);

          if (response.data.success) {
            console.log('account info query worked')

            const activeOrg = response.data.accountInfo.activeOrg
            let employerContactFirstName = response.data.accountInfo.employerContactFirstName
            let employerContactLastName = response.data.accountInfo.employerContactLastName
            let employerContactEmail = response.data.accountInfo.employerContactEmail

            this.setState({
                employerContactFirstName, employerContactLastName, employerContactEmail,
                employerName: response.data.accountInfo.employerName,
                workLocation: response.data.accountInfo.employerLocation
            });

            Axios.get('/api/postings/byid', { params: { _id: id } })
            .then((response) => {
              console.log('Posted jobs query attempted', response.data);

                if (response.data.success) {
                  console.log('posted jobs query worked')

                  const selectedJob = response.data.posting

                  let payRange = selectedJob.payRange
                  let pay = ''

                  if (selectedJob) {
                    if (payRange.includes(" - ")) {
                      let number1 = Number(payRange.substring(1,3))
                      let number2 = Number(payRange.substring(7,9))
                      pay = ((number1 + number2) / 2).toString()

                    } else if (payRange.includes("+")) {
                      pay = payRange.substring(1,4)
                    } else if (payRange === "Less") {
                      pay = '9'
                    } else if (payRange === "Unpaid") {
                      pay = '0'
                    } else if (payRange === "Wide Range") {
                      pay = '15'
                    }
                  }

                  let startDate = selectedJob.startDate
                  let endDate = selectedJob.endDate
                  let hoursPerWeek = selectedJob.hoursPerWeek

                  if (selectedJob.employerContactFirstName) {
                    employerContactFirstName = selectedJob.employerContactFirstName
                  }

                  if (selectedJob.employerContactLastName) {
                    employerContactLastName = selectedJob.employerContactLastName
                  }

                  if (selectedJob.employerContactEmail) {
                    employerContactEmail = selectedJob.employerContactEmail
                  }

                  this.setState({ selectedJob, pay, startDate, endDate, hoursPerWeek,
                    employerContactFirstName, employerContactLastName, employerContactEmail
                  })

                  const benchmarkId = selectedJob.benchmarkId

                  Axios.get('/api/benchmarks/byid', { params: { _id: benchmarkId} })
                  .then((response) => {
                    console.log('Benchmarks query attempted in DecideOnCandidate', response.data);

                    if (response.data.success) {
                      console.log('benchmark query worked')

                      const benchmark = response.data.benchmark
                      this.setState({ benchmark })

                      Axios.get('/api/applications/bypost', { params: { postingId: selectedJob._id } })
                      .then((response) => {
                        console.log('Applications query attempted', response.data);

                        if (response.data.success) {
                          console.log('applications query worked')

                          if (response.data.applications.length !== 0) {

                            this.calculateMatches(response.data.applications, selectedJob, benchmark)

                          }

                        } else {
                          console.log('applications query did not work', response.data.message)
                        }
                      }).catch((error) => {
                          console.log('Application query did not work for some reason', error);
                      });

                    } else {
                      console.log('benchmark query did not work', response.data.message)
                    }

                  }).catch((error) => {
                      console.log('Benchmark query did not work for some reason', error);
                  });

                } else {
                  console.log('posted jobs query did not work', response.data.message)
                }

            }).catch((error) => {
                console.log('Posted jobs query did not work for some reason', error);
            });

            Axios.get('/api/org', { params: { orgCode: activeOrg } })
            .then((response) => {
              console.log('Org info query attempted', response.data);

                if (response.data.success) {
                  console.log('org info query worked')

                  this.setState({
                      org: activeOrg,

                      orgName: response.data.orgInfo.orgName,
                      orgURL: response.data.orgInfo.orgURL,
                      orgType: response.data.orgInfo.orgType,
                      orgProgramName: response.data.orgInfo.orgProgramName,
                      orgDescription: response.data.orgInfo.orgDescription,
                      orgMission: response.data.orgInfo.orgMission,

                      orgContactFirstName: response.data.orgInfo.contactFirstName,
                      orgContactLastName: response.data.orgInfo.contactLastName,
                      orgContactTitle: response.data.orgInfo.contactTitle,
                      orgContactEmail: response.data.orgInfo.contactEmail,

                  });

                } else {
                  console.log('org info query did not work', response.data.message)
                }

              }).catch((error) => {
                console.log('Org info query did not work for some reason', error);
              });
          }
        }).catch((error) => {
          console.log('Account info query did not work for some reason', error);
        });

      } else {
        //this person needs to log in
      }

    }

    calculateMatches(applications, selectedJob, benchmark) {
      console.log('calculateMatches', applications, selectedJob, benchmark)

      let formHasChangedArray = []
      for (let i = 1; i <= applications.length; i++) {
        console.log(i, 'calculating matches');
        formHasChangedArray.push(false)

        //pull questions from backend
        const originalSkillQuestions = ["Adapting to new situations","Solving problems proactively","Being resilient in adversity","Working independently","Taking initiative and gathering resources (e.g. teammates, money) to solve a problem or reach a goal","Thinking critically","Analytical skills / sythesizing information","Actively listening","Reading","Writing","Speaking","Mathematics","Science","Being curious about unfamiliar things","Presentation skills","Being detail-Oriented","Being patient","Maintaining my integrity","Managing my time","Customer Service","Being flexible","Keeping myself accountable","Actively learning","Collaborating","Communicating","Being self-aware","Communicating in a non-english langauge","Empathizing","Leading others","Coordinating with others","Instructing others","Negotiating with others","Persuading others","Helping others proactively","Mentoring others, and vice versa","Teamwork with others","Being approachable","Being socially perceptive","How many hours best describes the time you have worked with spreadsheets (e.g. Microsoft Excel / Google Sheets)","Project Management","HTML and CSS","Javascript","Graphic / User Interface Design: creating enticing graphics / UI design for desired action or goal.","How many hours best describes the time you have spent learning and working on projects relevant to Software Development","Python","Java","Cloud Computing","PHP","SQL","Matlab","Perl","Go","iOS Development: Objective C or Swift","C or C++","C#","MongoDB, Cassandra, Couchbase, or HBase","Wordpress Development","Front-End Web Development","Back-End Web Development","Full-Stack Web Development","Android Mobile App Development","Game Development","Security Development","DevOps Engineer: making sure the development process goes smoothly for the development team through development tools","3rd Party APIs","How many hours best describes the time you have spent learning and working on projects relevant to Data Science","R","Hadoop, Hive, or Pig","Web Scraping","Machine Learning","How many hours best describes the time you have spent learning and working on projects relevant to Software Product Management","How many hours best describes the time you have spent learning and working on projects relevant to Digital Marketing","SEO / SEM","Analytics Software: for optimizing funnel / conversion rates","Copywriting","Video Creation: Engaging video content that leads to desired action / goals","Analytics Software: for optimizing funnel / conversion rates","Advertising: Managing paid content on advertising platforms (e.g. Google, Facebook) for desired action.","Messaging (e.g. Email, Push, Social Media) to prospective or current customers","Messaging (e.g. Email, Push, Social Media) to prospective or current customers","Storytelling","How many hours best describes the time you have spent learning and working on projects relevant to UX / UI Design","Wireframing","User Research","Fundamental Design Principals","Prototyping Tools","Adobe Photoshop","Adobe Illustrator","How many hours best describes the time you have spent learning and working on projects relevant to customer service for a technology product or service","Troubleshooting","Business Process Improvement","Windows Server","Microsoft Exchange","Active Directory","Disaster Recovery","Network Administration","System Administration","Linux","VMWare","How many hours best describes the time you have spent learning and working on projects relevant to sales or recruiting.","Account Management Software","Creating Prospective Lists: researching and creating lists of clients with a high liklihood of conversion","Managing Prospective Lists: To maximize relationship and conversions with prospective clients","Closing deals: convincing qualified / interested clients to partner or pay for a service","Breaking down and meeting goals: Breaking down larger goals into smaller ones, and meeting those goals."]
        console.log('please show plz', originalSkillQuestions.length, applications[i - 1].skillAnswers.length)
        console.log('okay show skillAnswers', applications[i - 1].skillAnswers)

        const skillQuestions = ["Adaptability","Creative Problem Solving","Determination","Independent","Actively Learning","Thinking critically","Analytical / Research-Oriented","Active Listening","Reading","Writing","Speaking","Mathematics","Science","Curiosity","Presentation Skills","Detail-Oriented","Patience","Integrity","Time Management","Customer Service","Being flexible","Keeping myself accountable","Actively learning","Collaboration","Communication","Being self-aware","Communicating in a non-english langauge","Empathy","Leading others","Coordinating with others","Training and Development","Negotiating with others","Persuading Others","Helping others proactively","Mentoring others, and vice versa","Teamwork","Being approachable","Being socially perceptive","Google Suite / Office 365","Project Management","HTML and CSS","Javascript","Graphic Design","How many hours best describes the time you have spent learning and working on projects relevant to Software Development","Python","Java","Cloud Computing","PHP","SQL","Matlab","Perl","Go","iOS Development","C or C++","C#","MongoDB or Cassandra","Wordpress Development","Front-End Web Development","Back-End Web Development","Full-Stack Web Development","Android Development","Game Development","Security Development","DevOps Engineer: making sure the development process goes smoothly for the development team through development tools","3rd Party APIs","How many hours best describes the time you have spent learning and working on projects relevant to Data Science","R","Hadoop or Hive","Web Scraping","Machine Learning","How many hours best describes the time you have spent learning and working on projects relevant to Software Product Management","Marketing Strategy","SEO and SEM","Analytics Software","Copywriting","Video Creation: Engaging video content that leads to desired action / goals","Analytics Software: for optimizing funnel / conversion rates","Advertising","Messaging (e.g. Email, Push, Social Media) to prospective or current customers","Messaging (e.g. Email, Push, Social Media) to prospective or current customers","Storytelling","How many hours best describes the time you have spent learning and working on projects relevant to UX / UI Design","Wireframing","User Research","Fundamental Design Principals","Prototyping Tools","Adobe Photoshop","Adobe Illustrator","How many hours best describes the time you have spent learning and working on projects relevant to customer service for a technology product or service","Troubleshooting","Business Process Improvement","Windows Server","Microsoft Exchange","Active Directory","Disaster Recovery","Network Administration","System Administration","Linux","VMWare","How many hours best describes the time you have spent learning and working on projects relevant to sales or recruiting.","Account Management Software","Creating Prospective Lists","Managing Prospective Lists","Closing deals: convincing qualified / interested clients to partner or pay for a service","Reaching Stretch Goals"]

        let selectedBenchmark = benchmark

        let interestsWeight = 0
        let interestsDifferential = 0
        let includeInterestsValue = 0
        if (applications[i - 1].interestResults.length !== 0) {
          includeInterestsValue = 1
          console.log('testing 456', selectedBenchmark)
          //interests
          interestsWeight = Number(selectedBenchmark.interests[0].weight) + Number(selectedBenchmark.interests[1].weight) + Number(selectedBenchmark.interests[2].weight) + Number(selectedBenchmark.interests[3].weight) + Number(selectedBenchmark.interests[4].weight) + Number(selectedBenchmark.interests[5].weight)

          let realisticScore1 = (applications[i - 1].interestResults[0].score / 40) * 100
          let realisticScore2 = selectedBenchmark.interests[0].score * 20
          let realisticDifferential = Math.abs(realisticScore1 - realisticScore2)
          let wRealistic = (realisticDifferential * (selectedBenchmark.interests[0].weight / interestsWeight))

          let investigativeScore1 = (applications[i - 1].interestResults[1].score / 40) * 100
          let investigativeScore2 = selectedBenchmark.interests[1].score * 20
          let investigativeDifferential = Math.abs(investigativeScore1 - investigativeScore2)
          let wInvestigative = (investigativeDifferential * (selectedBenchmark.interests[1].weight / interestsWeight))

          let artisticScore1 = (applications[i - 1].interestResults[2].score / 40) * 100
          let artisticScore2 = selectedBenchmark.interests[2].score * 20
          let artisticDifferential = Math.abs(artisticScore1 - artisticScore2)
          let wArtistic = (artisticDifferential * (selectedBenchmark.interests[2].weight / interestsWeight))

          let socialScore1 = (applications[i - 1].interestResults[3].score / 40) * 100
          let socialScore2 = selectedBenchmark.interests[3].score * 20
          let socialDifferential = Math.abs(socialScore1 - socialScore2)
          let wSocial = (socialDifferential * (selectedBenchmark.interests[3].weight / interestsWeight))

          let enterprisingScore1 = (applications[i - 1].interestResults[4].score / 40) * 100
          let enterprisingScore2 = selectedBenchmark.interests[4].score * 20
          let enterprisingDifferential = Math.abs(enterprisingScore1 - enterprisingScore2)
          let wEnterprising = (enterprisingDifferential * (selectedBenchmark.interests[4].weight / interestsWeight))

          let conventionalScore1 = (applications[i - 1].interestResults[5].score / 40) * 100
          let conventionalScore2 = selectedBenchmark.interests[5].score * 20
          let conventionalDifferential = Math.abs(conventionalScore1 - conventionalScore2)
          let wConventional = (conventionalDifferential * (selectedBenchmark.interests[5].weight / interestsWeight))

          interestsDifferential =  wRealistic + wInvestigative + wArtistic + wSocial + wEnterprising + wConventional

        }

        let skillsWeight = 0
        let skillsDifferential = 0
        let includeSkillsValue = 0
        let skillScores = []
        if (applications[i - 1].skillResults.length !== 0) {
          includeSkillsValue = 1

          let skillAnswers = applications[i - 1].skillAnswers

          let totalDifferential = 0
          for (let k = 1; k <= selectedBenchmark.skills.length; k++) {
            console.log(k, 'looping through benchmark skills');

            skillsWeight = skillsWeight + Number(selectedBenchmark.skills[k - 1].weight)

            if (skillQuestions.includes(selectedBenchmark.skills[k - 1].title)) {

              let questionIndex = skillQuestions.indexOf(selectedBenchmark.skills[k - 1].title)
              console.log('gimme the question index', questionIndex)
              let skillScore1 = Number(skillAnswers[questionIndex]) * 20
              let skillScore2 = selectedBenchmark.skills[k - 1].score * 20
              let skillDifferential = Math.abs(skillScore1 - skillScore2)
              totalDifferential = totalDifferential + skillDifferential

              skillScores.push({ title: selectedBenchmark.skills[k - 1].title, score: Number(skillAnswers[questionIndex])})
            } else {
              skillScores.push({ title: selectedBenchmark.skills[k - 1].title, score: 0})
            }
          }

          //cant figure out how to do weight so we devide evently for now
          skillsDifferential = totalDifferential / selectedBenchmark.skills.length

        }

        let traitsWeight = 0
        let traitsDifferential = 0
        let includeTraitsValue = 0
        if (applications[i - 1].personalityResults.length !== 0) {
          includeTraitsValue = 1

          //traits
          traitsWeight = Number(selectedBenchmark.traits[0].weight) + Number(selectedBenchmark.traits[1].weight) + Number(selectedBenchmark.traits[2].weight) + Number(selectedBenchmark.traits[3].weight) + Number(selectedBenchmark.traits[4].weight)

          let opennessScore1 = (applications[i - 1].personalityResults.fiveFactors.opennessScore / 16) * 100
          let opennessScore2 = selectedBenchmark.traits[0].score * 20
          let opennessDifferential = Math.abs(opennessScore1 - opennessScore2)
          let wOpenness = (opennessDifferential * (selectedBenchmark.traits[0].weight / traitsWeight))

          let conscientiousnessScore1 = (applications[i - 1].personalityResults.fiveFactors.conscientiousnessScore / 16) * 100
          let conscientiousnessScore2 = selectedBenchmark.traits[1].score * 20
          let conscientiousnessDifferential = Math.abs(conscientiousnessScore1 - conscientiousnessScore2)
          let wConscientiousness = (conscientiousnessDifferential * (selectedBenchmark.traits[1].weight / traitsWeight))

          let extraversionScore1 = (applications[i - 1].personalityResults.fiveFactors.extraversionScore / 16) * 100
          let extraversionScore2 = selectedBenchmark.traits[2].score * 20
          let extraversionDifferential = Math.abs(extraversionScore1 - extraversionScore2)
          let wExtraversion = (extraversionDifferential * (selectedBenchmark.traits[2].weight / traitsWeight))

          let agreeablenessScore1 = (applications[i - 1].personalityResults.fiveFactors.agreeablenessScore / 16) * 100
          let agreeablenessScore2 = selectedBenchmark.traits[3].score * 20
          let agreeablenessDifferential = Math.abs(agreeablenessScore1 - agreeablenessScore2)
          let wAgreeableness = (agreeablenessDifferential * (selectedBenchmark.traits[3].weight / traitsWeight))

          let neuroticismScore1 = (applications[i - 1].personalityResults.fiveFactors.neuroticismScore / 16) * 100
          let neuroticismScore2 = selectedBenchmark.traits[4].score * 20
          let neuroticismDifferential = Math.abs(neuroticismScore1 - neuroticismScore2)
          let wNeuroticism = (neuroticismDifferential * (selectedBenchmark.traits[4].weight / traitsWeight))

          traitsDifferential =  wOpenness + wConscientiousness + wExtraversion + wAgreeableness + wNeuroticism

          console.log('gimme traits', opennessDifferential, wOpenness, traitsWeight, traitsDifferential)

        }

        let interviewWeight = 0
        let interviewDifferential = 0
        let includeInterviewValue = 0

        if (selectedBenchmark.interview) {
          interviewWeight = selectedBenchmark.interview.weight
          includeInterviewValue = 1
          interviewDifferential = 5 * 20

          if (applications[i - 1].interview) {
            interviewDifferential = (5 - Number(applications[i - 1].interview.score)) * 20
          }
        }

        let combinedWeight = interestsWeight + skillsWeight + traitsWeight + interviewWeight
        let wInterests = includeInterestsValue * (interestsDifferential  * (interestsWeight / combinedWeight ))
        let wSkills = includeSkillsValue * (skillsDifferential * (skillsWeight / combinedWeight ))
        let wTraits = includeTraitsValue * (traitsDifferential * (traitsWeight / combinedWeight ))
        let wInterview = includeInterviewValue * (interviewDifferential * (interviewWeight / combinedWeight))

        let finalDifferential = wInterests + wSkills + wTraits + wInterview
        console.log('lets see final values', i, interestsDifferential, interestsWeight, wInterests, traitsDifferential, traitsWeight, wTraits, skillsDifferential, skillsWeight, wSkills,interviewDifferential, interviewWeight, wInterview, finalDifferential)
        console.log('what is finalDifferential again', Math.round(finalDifferential))

        applications[i - 1]['match'] = 100 - Math.round(finalDifferential)
        applications[i - 1]['skillScores'] = skillScores

        console.log('show me applications plz')
        //sort by rank actually

      }

      applications.sort(function(a,b) {
        return a.match - b.match;
      })

      this.setState({ applications, formHasChangedArray })
    }

    mobileNav (event) {
        console.log('mobile nav clicked')
        if (this.state.mobileNavClass === "side-nav") {
            this.setState({
                mobileNavClass: 'side-nav-mobile',
                isVisible: false
            })
        } else {
            this.setState({
                mobileNavClass: 'side-nav',
                isVisible: true
            })
        }
    }

    formChangeHandler = (event) => {
      console.log('formChangeHandler called')

      if (event.target.name === 'employerCode') {
        this.setState({ employerCode: event.target.value })
      } else if (event.target.name.includes('employerFeedback')) {
        let nameArray = event.target.name.split("|")
        let index = Number(nameArray[1])
        if (!index) {
          index = 0
        }

        let selectedApplication = this.state.selectedApplication
        selectedApplication['employerFeedback'] = event.target.value

        let formHasChangedArray = this.state.formHasChangedArray
        formHasChangedArray[index] = true
        console.log('show the values: ', selectedApplication, formHasChangedArray, index)
        this.setState({ selectedApplication, formHasChangedArray })

      } else if (event.target.name === 'startDate') {
        this.setState({ startDate: event.target.value })
      } else if (event.target.name === 'endDate') {
        this.setState({ endDate: event.target.value })
      } else if (event.target.name === 'isPerpetual') {
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({ isPerpetual: value, formHasChanged: true })
      } else if (event.target.name === 'hoursPerWeek') {
        this.setState({ hoursPerWeek: event.target.value })
      } else if (event.target.name === 'pay') {
        this.setState({ pay: event.target.value })
      } else if (event.target.name === 'isOnsite') {
        this.setState({ isOnsite: event.target.value })
      } else if (event.target.name === 'workLocation') {
        this.setState({ workLocation: event.target.value })
      } else if (event.target.name === 'offerLetterURL') {
        this.setState({ offerLetterURL: event.target.value })
      } else if (event.target.name === 'expirationDate') {
        this.setState({ expirationDate: event.target.value })
      }
    }

    likeClicked(isLiked, isDisliked, index) {
      console.log('likeClicked clicked', isLiked, isDisliked, index)

      let selectedApplication = this.state.selectedApplication
      if (isLiked) {
        if (selectedApplication.liked) {
          selectedApplication['liked'] = false
        } else {
          selectedApplication['liked'] = true
          selectedApplication['disliked'] = false
        }
      }

      if (isDisliked) {
        if (selectedApplication.disliked) {
          selectedApplication['disliked'] = false
        } else {
          selectedApplication['disliked'] = true
          selectedApplication['liked'] = false
        }
      }

      this.setState({ selectedApplication })

      const _id = this.state.selectedApplication._id
      const liked = this.state.selectedApplication.liked
      const disliked = this.state.selectedApplication.disliked
      const updatedAt = new Date()

      Axios.post('/api/applications/update-by-id', { //sessions: sessions
        _id, liked, disliked, updatedAt })
      .then((response) => {

        if (response.data.success) {
          //save values
          console.log('Your changes have been saved', response.data);

          this.setState({ serverSuccessMessage: 'Your changes have been saved' })

        } else {
          console.error('there was an error saving the application');
          this.setState({ serverErrorMessage: 'there was an error saving ' + response.data.message })
        }
      }).catch((error) => {
          console.log('Application save did not work', error);
          this.setState({ serverErrorMessage: 'there was an error saving ' + error })
      });
    }

    connectEmployer(index) {
      console.log('connectEmployer called', index)

      this.setState({ serverSuccessMessage: '', serverErrorMessage: ''})

      const requestToInterview = this.state.requestToInterview
      const accountCode = this.state.selectedJob.accountCode
      const postingId = this.state.selectedJob._id
      const postingName = this.state.selectedJob.title

      let candidateFirstName = this.state.selectedApplication.firstName
      let candidateLastName = this.state.selectedApplication.lastName
      let candidateEmail = this.state.selectedApplication.email
      const employerMessage = this.state.selectedApplication.employerMessage

      const orgName = this.state.orgName
      const orgContactFirstName = this.state.orgContactFirstName
      const orgContactLastName = this.state.orgContactLastName
      const orgContactEmail = this.state.orgContactEmail
      const orgContactTitle = this.state.orgContactTitle
      const orgProgramName = this.state.orgProgramName

      const employerName = this.state.employerName
      const employerContactFirstName = this.state.cuFirstName
      const employerContactLastName = this.state.cuLastName
      const employerContactEmail = this.state.emailId

      let orgMode = this.state.orgMode
      let placementPartners = this.state.selectedJob.placementPartners

      console.log('we got employerContactEmail ', employerContactEmail)

      //send email to employer
      Axios.post('/api/top-candidates/connect', {
        requestToInterview, accountCode, postingId, postingName,
        candidateFirstName, candidateLastName, candidateEmail, employerMessage,
        orgName, orgContactFirstName, orgContactLastName, orgContactEmail, orgContactTitle, orgProgramName,
        orgMode, placementPartners,
        employerName, employerContactFirstName, employerContactLastName, employerContactEmail
      })
      .then((response) => {

        if (response.data.success) {
          //save values
          console.log('Message successfully sent', response.data);
          this.setState({ serverSuccessMessage: response.data.message })

          // const connected = true
          // const updatedAt = new Date()

          let selectedApplication = this.state.selectedApplication
          selectedApplication['stage'] = 'Connected'
          if (requestToInterview) {
            selectedApplication['stage'] = 'Interview Requested'
          }
          this.setState({ serverSuccessMessage: 'Your changes have been saved', selectedApplication, modalIsOpen: false, showInterview: false })

        } else {
          console.error('there was an error sending the message');
          this.setState({ serverErrorMessage: 'There was an error sending out the message ' + response.data.message})
        }
      }).catch((error) => {
          console.log('there was an error sending the message', error);
          this.setState({ serverErrorMessage: 'There was an error sending out the message ' + error})
      });
    }

    saveFeedback(index) {
      console.log('saveFeedback called', index)

      const _id = this.state.selectedApplication._id
      const employerFeedback = this.state.selectedApplication.employerFeedback

      const postingName = this.state.selectedJob.title
      const candidateFirstName = this.state.selectedApplication.firstName
      const candidateLastName = this.state.selectedApplication.lastName
      const candidateEmail = this.state.selectedApplication.email
      const candidateUsername = this.state.selectedApplication.username
      const candidatePictureURL = this.state.selectedApplication.pictureURL
      const employerName = this.state.employerName
      const orgName = this.state.orgName

      const orgContactEmail = this.state.orgContactEmail

      const orgMode = this.state.orgMode
      const placementPartners = this.state.selectedJob.placementPartners

      const updatedAt = new Date()

      Axios.post('/api/applications/update-by-id', {
        _id, employerFeedback, postingName,
        candidateFirstName, candidateLastName, candidateEmail, candidateUsername, candidatePictureURL,
        employerName, orgName, orgMode, placementPartners, orgContactEmail, updatedAt })
      .then((response) => {

        if (response.data.success) {
          //save values
          console.log('Application save worked', response.data);

          this.setState({ serverSuccessMessage: 'Successfully saved!' })

        } else {
          console.error('there was an error saving the application');
          this.setState({ serverErrorMessage: 'there was an error saving ' + response.data.message })
        }
      }).catch((error) => {
          console.log('Application save did not work', error);
          this.setState({ serverErrorMessage: 'there was an error saving ' + error })
      });
    }

    makeOffer(index) {
      console.log('makeOffer called')

      const candidateIndex = index
      this.setState({ modalIsOpen: true, showEndorsements: false, showMatchDetails: false, showProjects: false, showTraits: false, showOffer: true, candidateIndex });
    }

    // viewDetails(type, index) {
    //   console.log('viewDetails ', type, index)
    //
    //   const candidateIndex = index
    //   if (type === 'endorsements') {
    //     this.setState({ modalIsOpen: true, showEndorsements: true, showMatchDetails: false, showProjects: false, showTraits: false, showOffer: false, showInterview: false, candidateIndex });
    //   } else if (type === 'match') {
    //     this.setState({ modalIsOpen: true, showEndorsements: false, showMatchDetails: true, showProjects: false, showTraits: false, showOffer: false, showInterview: false, candidateIndex });
    //   } else if (type === 'projects') {
    //     this.setState({ modalIsOpen: true, showEndorsements: false, showMatchDetails: false, showProjects: true, showTraits: false, showOffer: false, showInterview: false, candidateIndex });
    //   } else if (type === 'personality') {
    //     this.setState({ modalIsOpen: true, showEndorsements: false, showMatchDetails: false, showProjects: false, showTraits: true, showOffer: false, showInterview: false, candidateIndex });
    //   } else if (type === 'interview') {
    //     this.setState({ modalIsOpen: true, showEndorsements: false, showMatchDetails: false, showProjects: false, showTraits: false, showOffer: false, showInterview: true, candidateIndex });
    //   }
    // }

    // viewEndorsements(index) {
    //   console.log('viewEndorsements called')
    //
    //   this.setState({ modalIsOpen: true, showOffer: false, showEndorsements: true, showMatchDetails: false })
    //   //notate candidate selected?
    //   // this.openModal()
    // }

    // openModal() {
    //   this.setState({modalIsOpen: true});
    // }

    // afterOpenModal() {
    //   // references are now sync'd and can be accessed.
    //   //this.subtitle.style.color = '#f00';
    // }

    closeModal() {
      this.setState({ modalIsOpen: false, showOffer: false, showInterview: false });
    }

    sendOffer(index) {
      console.log('sendOffer sent')

      const applicationId = this.state.selectedApplication._id
      const firstName = this.state.selectedApplication.firstName
      const lastName = this.state.selectedApplication.lastName
      const email = this.state.selectedApplication.email

      const empContactFirstName = this.state.cuFirstName
      const empContactLastName = this.state.cuLastName
      const empContactEmail = this.state.emailId

      const orgContactEmail = this.state.orgContactEmail
      const orgCode = this.state.org
      const accountCode = this.state.emp
      const orgContactFirstName = this.state.orgContactFirstName
      const orgContactLastName = this.state.orgContactLastName
      const orgContactTitle = this.state.orgContactTitle
      const orgName = this.state.orgName
      const orgProgramName = this.state.orgProgramName

      const title = this.state.selectedJob.title
      const employerName = this.state.selectedJob.employerName

      const startDate = this.state.startDate
      const endDate = this.state.endDate
      const hoursPerWeek = this.state.hoursPerWeek
      const pay = this.state.pay
      const isOnsite = this.state.isOnsite
      const workLocation = this.state.workLocation
      const offerLetterURL = this.state.offerLetterURL
      const expirationDate = this.state.expirationDate

      const postingId = this.state.postingId
      const isPerpetual = this.state.isPerpetual
      const workFunction = this.state.workFunction
      const industry = this.state.industry
      const description = this.state.description
      const pathways = this.state.pathways
      const employerURL = this.state.employerURL

      const orgMode = this.state.orgMode
      const placementPartners = this.state.selectedJob.placementPartners

      const createdAt = new Date()
      const updatedAt = new Date()

      if (startDate === '') {
        this.setState({ serverErrorMessage: 'Please add a start date for the offer'})
      } else if (this.state.isPerpetual === false &&  endDate === '') {
        this.setState({ clientErrorMessage: 'please add the ideal end date or indicate that this is a perpetual role', isSaving: false })
      } else if (hoursPerWeek === '' ) {
        this.setState({ serverErrorMessage: 'Please add hours per week for the offer'})
      } else if (pay === '' ) {
        this.setState({ serverErrorMessage: 'Please add the amount of pay for the offer'})
      } else if (workLocation === '' ) {
        this.setState({ serverErrorMessage: 'Please add the work location for the offer'})
      } else if (offerLetterURL && offerLetterURL !== '' && !offerLetterURL.startsWith('http')) {
        this.setState({ serverErrorMessage: 'Please edit the offer letter url to start with http'})
      } else {

        //save offer and send email
        Axios.post('/api/applications/offer', {
          applicationId, firstName, lastName, email,
          title, employerName, orgContactEmail,
          startDate, endDate, hoursPerWeek, pay, isOnsite, workLocation, offerLetterURL, expirationDate,
          orgContactFirstName, orgContactLastName, orgContactTitle, orgName, orgProgramName,
          empContactFirstName, empContactLastName, empContactEmail, employerURL,
          orgCode, accountCode, orgMode, placementPartners,
          postingId, isPerpetual, workFunction, industry, description, pathways,
          createdAt, updatedAt
        }).then((response) => {

          if (response.data.success) {
            //save values
            console.log('Message successfully sent', response.data);

            let selectedApplication = this.state.selectedApplication
            selectedApplication['stage'] = 'Offer'

            this.setState({
              modalIsOpen: false, serverSuccessMessage: 'Offer sent to candidate! View and edit outstanding offers from your dashboard.', selectedApplication })

          } else {
            console.error('there was an error sending the message');
            this.setState({ serverErrorMessage: 'There was an error sending out the message ' + response.data.message})
          }
        }).catch((error) => {
            console.log('there was an error sending the message', error);
            this.setState({ serverErrorMessage: 'There was an error sending out the message ' + error})
        });
      }
    }

    render() {

      let feedbackPlaceholder = "…any feedback on this candidate? How can we improve recommended candidates?"
      if (this.state.orgMode) {
        feedbackPlaceholder = "…any feedback for " + this.state.orgName + " on this candidate? How can matches improve?"
      }

      return (
        <div>
          {(this.state.selectedApplication) && (
            <div>
              {(this.state.offer) && (
                <div className="row=10">
                  {(!this.state.offer.decision) && (
                    <p className="error-color">An offer has been extended to {this.state.offer.firstName} {this.state.offer.lastName} for this role.</p>
                  )}
                  {(this.state.offer.decision === 'accept') && (
                    <p className="error-color">{this.state.offer.firstName} {this.state.offer.lastName} has accepted your offer for this role.</p>
                  )}
                </div>
              )}

              <div className="clear" />
              <div className="spacer"/><div className="half-spacer"/>
              <p>{this.state.selectedApplication.employerMessage}</p>
              <div className="spacer"/><div className="half-spacer"/>
              <div>
                <div className="float-left right-padding">
                  <button className="btn background-button" onClick={() => this.likeClicked(true, false, this.state.selectedIndex)}><img src={( this.state.selectedApplication.liked === true) ? thumbsUpBlueIcon : thumbsUpIcon} alt="Guided Compass thumbs up icon" className="image-auto-30"/></button>
                </div>
                <div className="float-left right-padding">
                  <button className="btn background-button" onClick={() => this.likeClicked(false, true, this.state.selectedIndex)}><img src={( this.state.selectedApplication.disliked === true) ? thumbsDownOrangeIcon : thumbsDownIcon} alt="Guided Compass thumbs down icon" className="image-auto-30" /></button>
                </div>
                {this.state.orgName && (
                  <div>

                  {(this.state.offer && this.state.offer.email === this.state.selectedApplication.email && this.state.offerMessage) ? (
                    <div>
                      <p className="error-color">{this.state.offerMessage}</p>
                    </div>
                  ) : (
                    <div>
                      <div className="float-left right-padding">

                        {(this.state.selectedApplication.stage === 'Connected' || this.state.selectedApplication.stage === 'Interview Requested' || this.state.selectedApplication.stage === 'Offer' || this.state.selectedApplication.stage === 'Hired') ? (
                          <div className="white-text cta-color row-5 horizontal-padding-4 rounded-corners top-margin-negative-5 medium-background">
                            {(this.state.requestToInterview) ? (
                              <p>{this.state.selectedApplication.stage}</p>
                            ) : (
                              <p>{this.state.selectedApplication.stage}</p>
                            )}
                          </div>
                        ) : (
                          <button className="btn background-button" onClick={() =>  this.setState({ modalIsOpen: true, showInterview: true, candidateIndex: this.state.selectedIndex })}>
                            <div className="white-text cta-color row-5 horizontal-padding-4 rounded-corners top-margin-negative-5 cta-background-color">
                              {(this.state.requestToInterview) ? (
                                <p>Request an Interview</p>
                              ) : (
                                <p>Interview {this.state.selectedApplication.firstName}</p>
                              )}
                            </div>
                          </button>
                        )}
                      </div>

                      <div className="float-left right-padding">
                        {(this.state.selectedApplication.stage === 'Offer') ? (
                          <button className="btn background-button" onClick={() => this.makeOffer(this.state.selectedIndex)}>
                            <div className="white-text cta-color row-5 horizontal-padding-4 rounded-corners top-margin-negative-5 medium-background">
                              <p>Awaiting Response On Your Offer</p>
                            </div>
                          </button>
                        ) : (
                          <button className="btn background-button" onClick={() => this.makeOffer(this.state.selectedIndex)}>
                            <div className="cta-color cta-border row-5 horizontal-padding-4 rounded-corners top-margin-negative-5">
                              <p>Make an Offer</p>
                            </div>
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                  </div>
                )}
              </div>
              <div className="clear"/>
              {(this.state.serverSuccessMessage !== '') && <p className="success-message">{this.state.serverSuccessMessage}</p>}
              {(this.state.serverErrorMessage !== '') && <p className="error-message">{this.state.serverErrorMessage}</p>}
              <div className="spacer"/><div className="half-spacer"/>
              <textarea type="text" className="text-field" placeholder={feedbackPlaceholder} name={"employerFeedback|" + this.state.selectedIndex} value={this.state.selectedApplication.employerFeedback} onChange={this.formChangeHandler}></textarea>

              {(this.state.formHasChangedArray[this.state.selectedIndex]) && (
                <div>
                  <div className="spacer"/>
                  <button className="btn btn-squarish" onClick={() => this.saveFeedback(this.state.selectedIndex)}>Send Feedback</button>
                </div>
              )}
              {/*
              {(this.state.serverSuccessMessage !== '') && <p className="success-message">{this.state.serverSuccessMessage}</p>}
              {(this.state.serverErrorMessage !== '') && <p className="error-message">{this.state.serverErrorMessage}</p>}
              <div className="spacer" /><div className="spacer" /><div className="spacer" />

              <div className="row-20">
                <button className="btn btn-primary" onClick={() => this.saveApplication()}>Save Changes</button>
              </div>*/}

              { (this.state.checklistErrorMessage!== '') && <p className="error-message">{this.state.checklistErrorMessage}</p> }
              { (this.state.serverPostSuccess) ? (
                <div className="left-margin-30 row-20">
                  <p className="success-message">{this.state.serverSuccessMessage}</p>
                </div>
              ) : (
                <div className="left-margin-30 row-10">
                  <p className="error-message">{this.state.serverErrorMessage}</p>
                </div>
              )}

              <Modal
               isOpen={this.state.modalIsOpen}
               onAfterOpen={this.afterOpenModal}
               onRequestClose={this.closeModal}
               className="modal"
               overlayClassName="modal-overlay"
               contentLabel="Example Modal"
              >


                {(this.state.showInterview) && (
                  <div className="padding-20">
                    <p className="heading-text-3">Interview {this.state.selectedApplication.firstName} {this.state.selectedApplication.lastName}</p>
                    <p className="top-padding description-text-2">{this.state.selectedJob.title} @ {this.state.selectedJob.employerName}</p>
                    <div className="spacer" /><div className="spacer" /><div className="spacer" />

                    {(this.state.requestToInterview) ? (
                      <div>
                        <p>Guided Compass will send an email notification to {this.state.orgName} that you would like to {this.state.selectedApplication.firstName} {this.state.selectedApplication.lastName}.</p>
                      </div>
                    ) : (
                      <div>
                        {(this.state.orgMode) ? (
                          <p>Guided Compass will automatically send an email connecting you to {this.state.selectedApplication.firstName} for an interview, CCing {this.state.orgName}</p>
                        ) : (
                          <p>Guided Compass will automatically send an email connecting you to {this.state.selectedApplication.firstName} for an interview</p>
                        )}
                      </div>
                    )}

                    <div className="spacer"/><div className="spacer"/><div className="spacer" /><div className="spacer" />
                    {(this.state.serverErrorMessage !== '') && <p className="error-message">{this.state.serverErrorMessage}</p>}

                    <div className="display-inline right-padding">
                      <button className="btn btn-primary" onClick={() => this.connectEmployer(this.state.candidateIndex)}>Send</button>
                    </div>
                    <div className="display-inline">
                      <button className="btn btn-secondary" onClick={() => this.closeModal(this.state.candidateIndex)}>Close</button>
                    </div>

                    <div className="spacer"/>
                  </div>
                )}

                {(this.state.showOffer) && (
                  <div className="padding-20">
                    <p className="heading-text-4">Make an Offer to {this.state.selectedApplication.firstName} {this.state.selectedApplication.lastName}</p>
                    <p className="top-padding description-text-2">{this.state.selectedJob.title} @ {this.state.employerName}</p>
                    <div className="spacer" />

                    <div>
                      <div className="anonymous-checkmark">
                        <input type="checkbox" name="isPerpetual" checked={this.state.isPerpetual} onChange={this.formChangeHandler} />
                      </div>
                      <div className="anonymous-descriptor">
                        <label className="description-text-1">This role is continual</label>
                      </div>
                      <div className="clear"/>
                    </div>

                    <div className="row-10">
                      <div className="container-left">
                        <p className="description-text-2 description-text-color bottom-padding-5">Start Date</p>
                        <input type="date" className="date-field" placeholder="Add the start date..." name="startDate" value={this.state.startDate} onChange={this.formChangeHandler}></input>
                      </div>

                      <div className="container-right">
                        {(this.state.isPerpetual) ? (
                          <div>
                            <p className="description-text-2 description-text-color bottom-padding-5">End Date</p>
                            <label className="heading-text-6">Continual</label>
                          </div>
                        ) : (
                          <div>
                            <p className="description-text-2 description-text-color bottom-padding-5">End Date</p>
                            <input type="date" className="date-picker" placeholder="Add the end date..." name="endDate" value={this.state.endDate} onChange={this.formChangeHandler}></input>
                          </div>
                        )}
                      </div>
                      <div className="clear"/>
                    </div>

                    <div className="row-10">
                      <div className="container-left">
                        <p className="description-text-2 description-text-color bottom-padding-5">Hours / Week</p>
                        <select name="hoursPerWeek" value={this.state.hoursPerWeek} onChange={this.formChangeHandler} className="dropdown">
                          {this.state.hoursPerWeekOptions.map(value =>
                            <option key={value} value={value}>{value}</option>
                          )}
                        </select>
                      </div>
                      <div className="container-right">
                        <p className="description-text-2 description-text-color bottom-padding-5">Hourly Pay</p>
                        <input type="text" className="text-field" placeholder="Add pay..." name="pay" value={this.state.pay} onChange={this.formChangeHandler}></input>
                      </div>
                      <div className="clear" />
                    </div>

                    <div className="row-10">
                      <div className="container-left">
                        <p className="description-text-2 description-text-color bottom-padding-5">On-Site?</p>
                        <select name="isOnsite" value={this.state.isOnsite} onChange={this.formChangeHandler} className="dropdown">
                          {this.state.onsiteOptions.map(value =>
                            <option key={value} value={value}>{value}</option>
                          )}
                        </select>
                      </div>
                      <div className="container-right">
                        <p className="description-text-2 description-text-color bottom-padding-5">Work Address</p>
                        <input type="text" className="text-field" placeholder="Add the address..." name="workLocation" value={this.state.workLocation} onChange={this.formChangeHandler}></input>
                      </div>
                      <div className="clear" />
                    </div>

                    <div className="row-10">
                      <div className="container-left">
                        <p className="description-text-2 description-text-color bottom-padding-5">Offer Letter URL</p>
                        <input type="text" className="text-field" placeholder="Add the offer letter URL..." name="offerLetterURL" value={this.state.offerLetterURL} onChange={this.formChangeHandler}></input>
                      </div>
                      <div className="container-right">
                        <p className="description-text-2 description-text-color bottom-padding-5">Expiration Date</p>
                        <input type="date" className="date-field" placeholder="When does this expire..." name="expirationDate" value={this.state.expirationDate} onChange={this.formChangeHandler}></input>
                      </div>
                      <div className="clear" />
                    </div>

                    <div className="spacer"/><div className="half-spacer"/>
                    {(this.state.serverErrorMessage !== '') && <p className="error-message">{this.state.serverErrorMessage}</p>}

                    <div className="display-inline right-padding">
                      <button className="btn btn-primary" onClick={() => this.sendOffer(this.state.candidateIndex)}>Send</button>
                    </div>
                    <div className="display-inline">
                      <button className="btn btn-secondary" onClick={() => this.closeModal(this.state.candidateIndex)}>Close</button>
                    </div>

                    <div className="spacer"/>

                  </div>
                )}

              </Modal>
            </div>
          )}
        </div>
      )
    }
}

export default DecideOnCandidate;
